import { FC } from "react";
import styles from "./ActiveFilterItem.module.scss";

const ActiveFilterItem: FC<ActiveFilterItemProps> = ({labelTitle, labelContent, onClick}: ActiveFilterItemProps) => {
    return (
        <div className={`${styles.activeFilterItemContainer}`}>
            <div className={styles.activeFilterItem}>
                <div className={styles.activeFilterText}>
                    <span>
                        {`${labelTitle}: ${labelContent}`}
                    </span>
                </div>
                <div className={styles.closeButton} onClick={onClick}>x</div>
            </div>
        </div>
    )
}

export default ActiveFilterItem

interface ActiveFilterItemProps {
    labelTitle: string;
    labelContent: string;
    onClick: () => void;
}